import BtLayoutSidebar from "@/common/components/chat-messages/bt-layout-sidebar";
import InlineSidebar from "@extension/context/content/components/notes-sidebar/inline-sidebar";
import SidebarToggleButtons from "@/common/components/sidebar-toggle-buttons/sidebar-toggle-buttons";
import { loadUserMessagesAndCampaignsThunk } from "@/common/reducers/UserThunks";
import { AccessFormPopup } from "@common-components/access-form-popup/access-form-popup";
import ConditionalWrapper from "@common-components/conditional-wrapper/ConditionalWrapper";
import StartChatWithPhoneNumber from "@common-components/start-chat-with-phone-number/start-chat-with-phone-number";
import { SubscriptionUpgradePopup } from "@common-components/subscription-upgrade-popup/subscription-upgrade-popup";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import QrHowToScan from "@common-views/qr-view/qr-how-to-scan";
import QrModal from "@common-views/qr-view/qr-modal";
import { DBWaContactsCacheThunks } from '@common/reducers/DBServiceThunks';
import { postMessageWithResponse } from '@common/services/post-message-to-whatsapp-functions';
import TopHeaderMain from "@/extension/context/content/components/labels-feature/top-header-main";
import '@extension/context/content/services/contentMessageService';
import { Box, Stack } from "@mui/system";
import { useEffect } from 'react';
import { btLayoutSidebarActions } from "@common-reducers/BtLayoutSidebarReducer";
import { privateSetCurrentChat } from "@common-reducers/WhatsAppReducer";
import ContactList from './contactList ';

import { AddScheduledMessageButton } from "@extension/context/content/components/add-scheduled-message-button/add-scheduled-message-button";
import ScheduledMessageEditorPopup from "@extension/context/content/components/add-scheduled-message-button/scheduled-message-editor-popup";
import LabelsModals from "@extension/context/content/components/labels-feature/labels-modals";
import WhatsappFooter from "./whatsapp-footer";
import ReminderEditorDialog from "@common/components/reminders/ReminderEditorDialog";
import { TestReminderDialog } from "@/website/views/test-reminder/TestReminderDialog";

const WhatsappView = () => {
  const dispatch = useAppDispatch();
  const userId = useAppSelector((state) => state.UserReducer.userId);

  const userMessages = useAppSelector((state) => state.DBUserMessageReducer.entities);

  window.addEventListener("message", (event) => {
    switch (event.data.cmd) {
      case "focusContact": {
        postMessageWithResponse({
          cmd: "currentChat",
          data: {
            id: { _serialized: event.data.data }
          }
        });
        break;
      }
    }

    return false;
  })


  useEffect(() => {
    // Emulate WhatsApp Web message handling so postMessage-based flows work in the website
    const handleWindowMessage = (event: MessageEvent) => {
      const data: any = event?.data;
      if (!data || typeof data !== 'object') return;

      // When UI posts { cmd: "currentChat", data: { id: { _serialized } } }, select chat in Redux
      if (data.cmd === 'currentChat') {
        const serializedId = data?.data?.id?._serialized || data?.id?._serialized || data?.id || data?.data;
        if (serializedId) {
          const chat: any = { id: { _serialized: serializedId } };
          dispatch(privateSetCurrentChat(chat));
          dispatch(btLayoutSidebarActions.openWithComponent('ChatScheduledMessages'));
        }
        // Respond back through MessageChannel if provided
        if (event.ports && event.ports[0]) {
          event.ports[0].postMessage({ status: 'ok' });
        }
      }
    };

    window.addEventListener('message', handleWindowMessage);

    if (userId) {
      dispatch(DBWaContactsCacheThunks.find({
        $forceContactsUpdate: false
      }));
    }
    dispatch(loadUserMessagesAndCampaignsThunk())

    return () => {
      window.removeEventListener('message', handleWindowMessage);
    }
  }, [dispatch, userId]);

  return (
    <div>
      <TopHeaderMain />
      <Stack direction="row">
        <ContactList />
        <Box>
          {/* {currentChatId ? <ChatBox /> : <Box>No chat selected</Box>} */}
          <Stack direction="row" style={{ marginTop: "25px" }}>
            <WhatsappFooter />
            <AddScheduledMessageButton />
          </Stack>
        </Box>
      </Stack>

      <AccessFormPopup />

      <ConditionalWrapper shouldLoadSelector={(state) => !!state.UserReducer.userId}>
        <QrModal />
        <QrHowToScan />
        <SubscriptionUpgradePopup />
      </ConditionalWrapper>

      <StartChatWithPhoneNumber />
      <BtLayoutSidebar excludedComponents={['Notes', 'Tasks', 'Reminders', 'QuickAgents']} />
      <InlineSidebar />
      <SidebarToggleButtons />
      <ScheduledMessageEditorPopup />
      <LabelsModals />
      <ReminderEditorDialog />
      <TestReminderDialog />
    </div>
  );
};

export default WhatsappView;
